import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewStandardQuoteComponent } from './standard-quote/new-standard-quote.component';
import { NewOpenQuoteComponent } from './open-quote/new-open-quote.component';
import { AuthGuard } from '@app/common/auth.guard';
import { ListOpenQuoteComponent } from './open-quote/list-open-quote/desktop/list-open-quote.component';
import { FinancialSetupComponent } from './standard-quote/catalogs/financial-setup/financial-setup.component';
import { NewFinancialSetupComponent } from './standard-quote/catalogs/financial-setup/new-financial-setup/new-financial-setup.component';
import { ListFinancialSetupComponent } from './standard-quote/catalogs/financial-setup/list-financial-setup/list-financial-setup.component';
import { ListFinancialProductComponent } from './standard-quote/catalogs/financial-product/list-financial-product/list-financial-product.component';
import { NewFinancialProductComponent } from './standard-quote/catalogs/financial-product/new-financial-product/new-financial-product-component/new-financial-product.component';
import { GeneralInformationReadonlyComponent } from './standard-quote/catalogs/financial-setup/new-financial-setup/components/general-information/general-information-readonly/general-information-readonly.component';
import { NewFinancialProductReadonlyComponent } from './standard-quote/catalogs/financial-product/new-financial-product/new-financial-product-readonly/new-financial-product-readonly.component';
import { BrandComponent } from './standard-quote/catalogs/brand/brand.component';
import { SubBrandComponent } from './standard-quote/catalogs/sub-brand/sub-brand.component';
import { ListPlanPisoComponent } from './standard-quote/catalogs/plan-piso/list-plan-piso/list-plan-piso.component';
import { NewPlanPisoComponent } from './standard-quote/catalogs/plan-piso/new-plan-piso/new-plan-piso.component';
import { ListStandardQuotePageComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-standard-quote-page.component';
import { NewDealStandardQuotePageComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/new-deal-standard-quote/new-deal-standard-quote-page.component';
import { CatalogsComponent } from './standard-quote/catalogs/catalogs.component';
import { ListRegionDrmCatalogComponent } from './standard-quote/catalogs/region-drm/list-region-drm-catalog.component';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    path: 'open-quote',
    component: ListOpenQuoteComponent,
    data: {
      breadcrumb: {
        title: 'INICIO',
        parent: 'Cotizador comercial',
        path: '',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote',
    component: ListStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'INICIO',
        parent: 'Cotizador de Distribuidores',
        path: '',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote',
    component: NewStandardQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Nueva cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id',
    component: NewStandardQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'open-quote/new-open-quote',
    component: NewOpenQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador comercial',
        children: 'Nueva cotización',
        path: 'quote/open-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'edit-quote-open/:id',
    component: NewOpenQuoteComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador comercial',
        children: 'Editar cotización',
        path: 'quote/open-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote/new-deal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/new-quote/edit-deal/:idDeal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id/edit-deal/:idDeal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'standard-quote/edit-quote/:id/new-deal',
    component: NewDealStandardQuotePageComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Cotizador de Distribuidores',
        children: 'Editar cotización',
        path: 'quote/standard-quote',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs',
    component: CatalogsComponent,
    data: {
      breadcrumb: {
        title: 'MENU',
        parent: 'Catalogos',
        path: 'catalogs',
      },
      module: 'Catalogos',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-setup',
    component: FinancialSetupComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Configuración del paquete financiero',
        path: 'financial-setup',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-setup/list',
    component: ListFinancialSetupComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Paquetes financieros',
        path: 'financial-setup/list',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-setup/new-setup',
    component: NewFinancialSetupComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Nuevo paquete financiero',
        path: 'financial-setup/new-setup',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-setup/edit-setup/:id',
    component: NewFinancialSetupComponent,
    data: {
      breadcrumb: {
        title: 'COTIZADOR',
        parent: 'Editar paquete financiero',
        path: 'financial-setup/edit-setup/:id',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-setup/read-only/:id',
    component: GeneralInformationReadonlyComponent,
    data: {
      breadcrumb: {
        title: 'Paquetes financieros',
        path: 'financial-setup/read-only/:id',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-product/list',
    component: ListFinancialProductComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Productos',
        path: 'catalogs',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-product/new-product',
    component: NewFinancialProductComponent,
    data: {
      breadcrumb: {
        title: 'PRODUCTOS',
        parent: 'Productos',
        path: 'financial-product/new-product',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-product/edit-product/:id',
    component: NewFinancialProductComponent,
    data: {
      breadcrumb: {
        title: 'PRODUCTOS',
        parent: 'Productos',
        path: 'financial-product/edit-product/:id',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'financial-product/read-only/:id',
    component: NewFinancialProductReadonlyComponent,
    data: {
      breadcrumb: {
        title: 'PRODUCTOS',
        parent: 'Productos',
        path: 'financial-product/read-only/:id',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/brand',
    component: BrandComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Marcas',
        path: 'catalogs',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/sub-brand',
    component: SubBrandComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Submarcas',
        path: 'catalogs',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/region-drm',
    component: ListRegionDrmCatalogComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Región / DRM',
        path: 'catalogs',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/plan-piso/list',
    component: ListPlanPisoComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Plan Piso',
        path: 'catalogs',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/plan-piso/new',
    component: NewPlanPisoComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Nuevo Plan Piso',
        path: 'catalogs/plan-piso/list',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/plan-piso/edit/:id',
    component: NewPlanPisoComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Editar Plan Piso',
        path: 'catalogs/plan-piso/list',
      },
      module: 'Cotizador',
    },
  },
  {
    canActivate: [AuthGuard],
    path: 'catalogs/plan-piso/view/:id',
    component: NewPlanPisoComponent,
    data: {
      breadcrumb: {
        title: 'CATALOGOS',
        parent: 'Ver Plan Piso',
        path: 'catalogs/plan-piso/list',
      },
      module: 'Cotizador',
    },
  },

];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class QuoteRoutingModule { }
